// Get values from environment variables if available
// Handle both browser (Vite) and SSR (Remotion) contexts
const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};

export const config = {
  API_URL: env.VITE_API_URL || '',
  STRIPE_PUBLIC_KEY: env.VITE_STRIPE_PUBLIC_KEY || '',
  CLERK_PUBLISHABLE_KEY: env.VITE_CLERK_PUBLISHABLE_KEY || '',
  IS_PRODUCTION: env.MODE === 'production',
}; 